import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDetallePorCerealLinea3Actions'
import { TablaDetallePorCerealLinea3View } from '../components/TablaDetallePorCerealLinea3View'

class TablaDetallePorCerealLinea3 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaDetallePorCerealLinea3View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDetallePorCerealLinea3)
